module.exports = {
          srcSet: __webpack_public_path__ + "3a9d4f56f6dbaf16b581847e88443157-60.png"+" 60w",
          images:[ {path: __webpack_public_path__ + "3a9d4f56f6dbaf16b581847e88443157-60.png",width: 60,height: 4}],
          src: __webpack_public_path__ + "3a9d4f56f6dbaf16b581847e88443157-60.png",
          toString:function(){return __webpack_public_path__ + "3a9d4f56f6dbaf16b581847e88443157-60.png"},
          
          width: 60,
          height: 4
        }